import React, { useEffect, useRef, useState } from 'react';
import { Routes, Route, useLocation, Link } from 'react-router-dom';
import { FaChevronDown, FaSignOutAlt } from 'react-icons/fa';
import ContratoForm from './components/ContratoForm';
import Contratos from './components/Contratos';
import ClienteForm from './components/ClienteForm';
import Clientes from './components/Clientes';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Sidebar from './components/Sidebar';
import { rolesMapping } from './utils/RolesUtils';
import { getUserLogged, hasAnyRole } from './utils/TokenUtils';
import { useAuth } from './AuthProvider';
import Colaboradores from './components/Colaboradores';
import ColaboradorForm from './components/ColaboradorForm';
import logo from "./logo-header.png";
import ComissaoForm from './components/ComissaoForm';
import ConfigDespesas from './components/contasapagar/configdespesa/ConfigDespesas';
import ConfigDespesasForm from './components/contasapagar/configdespesa/ConfigDespesasForm';
import Despesas from './components/contasapagar/despesa/Despesas';
import DespesaForm from './components/contasapagar/despesa/DespesaForm';
import BalancoFinanceiroForm from './components/BalancoFinanceiroForm';
import UsuariosAdmin from './components/UsuariosAdmin';
import UsuarioAdminForm from './components/UsuarioAdminForm';

function MainContent() {
    const location = useLocation();
    const { isAuthenticated, handleLogin, handleLogout, shouldShowLoginModal } = useAuth();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [openUser, setOpenUser] = useState(false);
    const userRef = useRef();

    const routesMapping = [
        {route: <Route key='contratos' path="/contratos" element={<Contratos />} />, rolesMapping: [...rolesMapping.contratos, ...rolesMapping.admin] },
        {route: <Route key='contratosCadastro' path="/contratos/cadastro" element={<ContratoForm />} />, rolesMapping: [...rolesMapping.contratos, ...rolesMapping.admin] },
        {route: <Route key='contratosCadastroId' path="/contratos/cadastro/:id" element={<ContratoForm />} />, rolesMapping: [...rolesMapping.contratos, ...rolesMapping.admin] },

        // {ute: <Route k=: '',  path="/contratos" element={<Contratos />} />, rolesMapping: [...rolesMapping.contratos, ...rolesMapping.admin] },
        {route: <Route key='comissao' path="/comissao" element={<ComissaoForm />} />, rolesMapping: [...rolesMapping.comissao, ...rolesMapping.admin] },
        
        {route: <Route key='clientes' path="/clientes" element={<Clientes />} />, rolesMapping: [...rolesMapping.clientes, ...rolesMapping.admin] },
        {route: <Route key='clientesCadastro' path="/clientes/cadastro" element={<ClienteForm />} />, rolesMapping: [...rolesMapping.clientes, ...rolesMapping.admin] },
        {route: <Route key='clientesCadastroId' path="/clientes/cadastro/:id" element={<ClienteForm />} />, rolesMapping: [...rolesMapping.clientes, ...rolesMapping.admin] },

        {route: <Route key='colaboradores' path="/colaboradores" element={<Colaboradores />} />, rolesMapping: [...rolesMapping.colaboradores, ...rolesMapping.admin] },
        {route: <Route key='colaboradoresCadastro' path="/colaboradores/cadastro" element={<ColaboradorForm />} />, rolesMapping: [...rolesMapping.colaboradores, ...rolesMapping.admin] },
        {route: <Route key='colaboradoresCadastroId' path="/colaboradores/cadastro/:id" element={<ColaboradorForm />} />, rolesMapping: [...rolesMapping.colaboradores, ...rolesMapping.admin] },

        {route: <Route key='configdespesas' path="/configdespesas" element={<ConfigDespesas />} />, rolesMapping: [...rolesMapping.configdespesas, ...rolesMapping.admin] },
        {route: <Route key='configdespesasCadastro' path="/configdespesas/cadastro" element={<ConfigDespesasForm />} />, rolesMapping: [...rolesMapping.configdespesas, ...rolesMapping.admin] },
        {route: <Route key='configdespesasCadastroId' path="/configdespesas/cadastro/:id" element={<ConfigDespesasForm />} />, rolesMapping: [...rolesMapping.configdespesas, ...rolesMapping.admin] },

        {route: <Route key='despesas' path="/despesas" element={<Despesas />} />, rolesMapping: [...rolesMapping.despesas, ...rolesMapping.admin] },
        {route: <Route key='despesasCadastro' path="/despesas/cadastro" element={<DespesaForm />} />, rolesMapping: [...rolesMapping.despesas, ...rolesMapping.admin] },
        {route: <Route key='despesasCadastroId' path="/despesas/cadastro/:id" element={<DespesaForm />} />, rolesMapping: [...rolesMapping.despesas, ...rolesMapping.admin] },

        {route: <Route key='balancofinanceiro' path="/balancofinanceiro" element={<BalancoFinanceiroForm />} />, rolesMapping: [...rolesMapping.balancofinanceiro, ...rolesMapping.admin] },
        {route: <Route key='usuariosAdmin' path="/admin/usuarios" element={<UsuariosAdmin />} />, rolesMapping: [...rolesMapping.admin, ...rolesMapping.admin] },
        {route: <Route key='usuarioAdminCadastro' path="/admin/usuarios/cadastro/:id" element={<UsuarioAdminForm />} />, rolesMapping: [...rolesMapping.admin, ...rolesMapping.admin] },

    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (userRef.current && !userRef.current.contains(event.target)) {
            setOpenUser(false);
          }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, []);

    const getTokenValidateRoles = () => {
        return isAuthenticated ? localStorage.getItem('access_token') : localStorage.getItem('expired_access_token');
    }

    const header = () => (
        <header className="main-header">
            
            <button className="hamburger-button" aria-label="Abrir menu" onClick={() => setOpenSidebar(!openSidebar)}>
                <span></span>
                <span></span>
                <span></span>
            </button>

            <div className="header-title">
                <img src={logo} alt="Gsult Consultoria" className="logo-center" />
            </div>

            <div className="user-badge-wrapper" ref={userRef}>
                <button type="button" className="user-badge-fixed" onClick={() => setOpenUser(!openUser)} aria-expanded={openUser}>
                    <i className="fas fa-user"></i>
                    <span className="user-name">{getUserLogged()}</span>
                    <FaChevronDown className="user-chevron" aria-hidden="true" />
                </button>
                {openUser &&
        <div className="user-dropdown">
          <button type="button" onClick={handleLogout}><FaSignOutAlt aria-hidden="true" /> Sair</button>
        </div>
      }
            </div>
        </header>
    )

    return (
        <div className="App">
            

            {isAuthenticated && (location.pathname != '/' && location.pathname != '/login') && header()}
            {(isAuthenticated || shouldShowLoginModal) && <Sidebar handleLogout={handleLogout} openSidebar={openSidebar} />}
            <div className="content">



                {(isAuthenticated || shouldShowLoginModal) ? (
                    <Routes>
                        {routesMapping.filter(route => hasAnyRole(route.rolesMapping, getTokenValidateRoles())).map(route => route.route)}
                        <Route path="*" element={<Dashboard handleLogout={handleLogout} />} />
                    </Routes>
                ) : (
                    <Routes>
                        <Route path="*" element={<Login handleLogin={handleLogin} />} />
                    </Routes>
                )}
            </div>
        </div>
    );
}

export default MainContent;
